import { Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

export function QueueFilter({ onFiltered }) {
    const [queues, setQueues] = useState([]);
    const [selecteds, setSelecteds] = useState([]);

    useEffect(() => {
        async function fetchData() {
            await loadQueues();
        }
        fetchData();
    }, []);

    const loadQueues = async () => {
        try {
            const { data } = await api.get(`/queue`);
            setQueues(data);
        } catch (err) {
            toastError(err);
        }
    };

    const onChange = async (value) => {
        setSelecteds(value);
        onFiltered(value);
    };

    return (
        <Autocomplete
            multiple
            size="small"
            options={queues}
            value={selecteds}
            onChange={(e, v, r) => onChange(v)}
            getOptionLabel={(option) => option.name}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip
                        variant="outlined"
                        style={{
                            backgroundColor: option.color || "#eee",
                            textShadow: "1px 1px 1px #000",
                            color: "white",
                        }}
                        label={option.name}
                        {...getTagProps({ index })}
                        size="small"
                    />
                ))
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    placeholder={i18n.t("filters.queues")}
                    fullWidth
                    style={{
                        backgroundColor: '#f5f5f5',
                    }}
                    InputProps={{
                        ...params.InputProps,
                        style: {
                            backgroundColor: '#f5f5f5',
                            borderRadius: 8,
                        }
                    }}
                />
            )}
        />
    );
}
